import { motion } from "framer-motion";

const float = (d = 0, a = 8) => ({ animate: { y: [0, -a, 0] }, transition: { duration: 6, delay: d, repeat: Infinity, ease: "easeInOut" } });

const Defs = ({ id }) => (
  <defs>
    <radialGradient id={`${id}-spot`} cx="50%" cy="0%" r="90%">
      <stop offset="0%" stopColor="#FFFFFA" stopOpacity="0.32" />
      <stop offset="60%" stopColor="#FFFFFA" stopOpacity="0" />
    </radialGradient>
    <radialGradient id={`${id}-pearl`} cx="38%" cy="32%" r="70%">
      <stop offset="0%" stopColor="#FFFFFF" />
      <stop offset="45%" stopColor="#F4EFE3" />
      <stop offset="80%" stopColor="#B9CFC7" />
      <stop offset="100%" stopColor="#7C9C93" />
    </radialGradient>
    <linearGradient id={`${id}-gold`} x1="0" y1="0" x2="1" y2="1">
      <stop offset="0%" stopColor="#F3D9A6" />
      <stop offset="50%" stopColor="#AB7F3E" />
      <stop offset="100%" stopColor="#E9CF9C" />
    </linearGradient>
    <linearGradient id={`${id}-plinth`} x1="0" y1="0" x2="0" y2="1">
      <stop offset="0%" stopColor="#0A4A44" />
      <stop offset="100%" stopColor="#011513" />
    </linearGradient>
  </defs>
);

const Plinth = ({ id, h }) => (
  <g>
    <rect x="80" y={300 - h} width="140" height={h} fill={`url(#${id}-plinth)`} />
    <ellipse cx="150" cy={300 - h} rx="70" ry="12" fill="#0A4A44" stroke="#D8BB86" strokeOpacity="0.5" />
  </g>
);

const Essential = ({ id }) => (
  <>
    <Plinth id={id} h={50} />
    <motion.g {...float(0)}>
      <ellipse cx="150" cy="170" rx="72" ry="16" fill="none" stroke={`url(#${id}-gold)`} strokeWidth="1.5" />
      <circle cx="150" cy="160" r="42" fill={`url(#${id}-pearl)`} />
      <ellipse cx="136" cy="142" rx="12" ry="7" fill="#FFFFFF" opacity="0.7" />
    </motion.g>
  </>
);

const Standard = ({ id }) => (
  <>
    <Plinth id={id} h={80} />
    <motion.g {...float(0.4)}>
      <g style={{ transformOrigin: "150px 140px" }}>
        <ellipse cx="150" cy="140" rx="76" ry="26" fill="none" stroke={`url(#${id}-gold)`} strokeWidth="7" transform="rotate(-28 150 140)" />
        <ellipse cx="150" cy="140" rx="76" ry="26" fill="none" stroke="#FFFFFA" strokeOpacity="0.85" strokeWidth="4" transform="rotate(28 150 140)" />
      </g>
      <circle cx="150" cy="140" r="16" fill={`url(#${id}-pearl)`} />
    </motion.g>
  </>
);

const Premium = ({ id }) => (
  <>
    <Plinth id={id} h={110} />
    <motion.g {...float(0.8, 6)}>
      <ellipse cx="150" cy="118" rx="96" ry="20" fill="none" stroke="#D8BB86" strokeOpacity="0.5" />
      <ellipse cx="150" cy="118" rx="80" ry="34" fill="none" stroke="#FFFFFA" strokeOpacity="0.35" transform="rotate(24 150 118)" />
      <polygon points="150,52 196,92 150,170 104,92" fill={`url(#${id}-gold)`} fillOpacity="0.85" stroke="#F3D9A6" />
      <polyline points="104,92 196,92" fill="none" stroke="#FFFFFA" strokeOpacity="0.8" />
      <polyline points="150,52 128,92 150,170 172,92 150,52" fill="none" stroke="#FFFFFA" strokeOpacity="0.5" />
      {[[80, 70], [222, 66], [60, 140], [240, 150], [110, 40], [196, 30], [150, 22]].map(([x, y], i) => (
        <motion.circle key={i} cx={x} cy={y} r={i % 2 ? 2 : 3} fill="#F3D9A6" animate={{ opacity: [0.2, 1, 0.2] }} transition={{ duration: 2.6, delay: i * 0.3, repeat: Infinity }} />
      ))}
    </motion.g>
  </>
);

const KINDS = [Essential, Standard, Premium];

export const Sculpture = ({ kind }) => {
  const K = KINDS[kind];
  const id = `sc${kind}`;
  return (
    <svg viewBox="0 0 300 320" className="h-full w-full" aria-hidden>
      <Defs id={id} />
      <rect width="300" height="320" fill={`url(#${id}-spot)`} className="opacity-70 transition-opacity duration-700 group-hover:opacity-100" />
      <ellipse cx="150" cy="300" rx="120" ry="10" fill="#000" opacity="0.35" />
      <K id={id} />
    </svg>
  );
};
